import React from 'react';
import Typography from '@mui/material/Typography';
import { OnboardingPage } from '../ui';

const PageNotFound = () => {
  return (
    <OnboardingPage title="Page Not Found">
      <Typography sx={{ fontSize: 24, py: 6, textAlign: 'center' }}>
        Error 404 - page not found :(
      </Typography>
    </OnboardingPage>
  );
};

export default PageNotFound;
